/**
 * Use this function to reset a user’s identity to an anonymous state after they have logged out.
 */
export function reset() {
  try {
    window.analytics?.reset();
    window.DD_RUM?.clearUser();
  } catch {
    console.warn("Failed to reset analytics identity");
  }
}
